import { fetchFromOldApi } from '~/services/Http';

export type ResetPasswordType = {
  fLoginUserEmail: string | undefined;
  fLoginUsername: string | undefined;
};

export const postRestPassword = async (json: ResetPasswordType) => {
  return await fetchFromOldApi('/form/user/reset', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(json),
  }).then((r) => r.json());
};
